import type { ValidationErrorResponse } from "./ValidationErrorResponse";
import type { ErrorResponse } from "./ErrorResponse";
import type { UploadContentRequest } from "./UploadContentRequest";
import type { OkResponse } from "./OkResponse";

export enum UploadFundingDocumentQueryParamsType {
    "LOAN_CONTRACT" = "LOAN_CONTRACT",
    "MORGAGE_CONTRACT" = "MORGAGE_CONTRACT",
    "LOAN_APPLICATION" = "LOAN_APPLICATION"
}
export type UploadFundingDocumentQueryParams = {
    /**
     * @type integer int64
    */
    fundingRequestId: number;
    /**
     * @type string date-time
    */
    version: string;
    /**
     * @type string | undefined
    */
    type?: UploadFundingDocumentQueryParamsType;
};

/**
 * @description Bad Request
*/
export type UploadFundingDocument400 = ValidationErrorResponse;

/**
 * @description Unauthorized
*/
export type UploadFundingDocument401 = ErrorResponse;

/**
 * @description Forbidden
*/
export type UploadFundingDocument403 = ErrorResponse;

/**
 * @description Not Found
*/
export type UploadFundingDocument404 = ErrorResponse;

/**
 * @description Gone
*/
export type UploadFundingDocument410 = ValidationErrorResponse;

/**
 * @description Unprocessable Entity
*/
export type UploadFundingDocument422 = ValidationErrorResponse;

/**
 * @description Too Many Requests
*/
export type UploadFundingDocument429 = ErrorResponse;

/**
 * @description Internal Server Error
*/
export type UploadFundingDocument500 = ErrorResponse;

export type UploadFundingDocumentMutationRequest = UploadContentRequest;

/**
 * @description OK
*/
export type UploadFundingDocumentMutationResponse = OkResponse;
